import React from "react";
import { Route, Switch } from "react-router-dom";
import asyncComponent from "../../util/asyncComponent";

const Groups = ({ match }) => (
  <div className="app-wrapper">
    <Switch>
      <Route
        path={`${match.url}/`}
        component={asyncComponent(() => import("./GroupsPage"))}
      />
      {/*<Route path={`${match.url}/add-group`} component={asyncComponent(() => import('./AddGroup'))}/>*/}
      <Route
        component={asyncComponent(() =>
          import("app/routes/extraPages/routes/404")
        )}
      />
    </Switch>
  </div>
);

export default Groups;
